import React, { useEffect } from 'react';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import { FastestDeliveries, IResDashboard } from '@/types/parcel/dashboard';

import { useDate } from '../Context/DateContext';

interface StateData {
  data: FastestDeliveries['orders'] | null;
  record: FastestDeliveries['orders'][0] | null;
  loading: boolean;
  error: boolean;
}

const useFastestDeliveries = () => {
  const { selectedDate } = useDate();
  const [data, setData] = React.useState<StateData>({
    data: null,
    record: null,
    loading: true,
    error: false,
  });

  const getFastestDeliveries = async () => {
    const http = initializeHttpProvider();
    try {
      const response = await http.dashboard.fastestDeliveries(selectedDate);
      const sortedData = (response as IResDashboard<FastestDeliveries>).data?.orders?.sort(
        (a, b) => a.durationMin - b.durationMin,
      );

      const record = sortedData?.shift() || null;

      setData({
        record,
        data: sortedData,
        loading: false,
        error: false,
      });
    } catch {
      setData({ data: null, loading: false, error: true, record: null });
    }
  };

  useEffect(() => {
    getFastestDeliveries();
  }, [selectedDate]);

  return {
    data,
  };
};

export default useFastestDeliveries;
